import React from "react";
import { connect } from "react-redux";
import ProductForm from "../../ProductForm";
import { IProduct, addProduct } from "../../../redux/modules/products";
import history from "../../../history";
import "./create-product.css";

interface CreateProductPageProps {
  addProduct?: (product: IProduct) => void;
}

class CreateProductPage extends React.Component<CreateProductPageProps> {
  saveProductHandler = (product: IProduct) => {
    this.props.addProduct && this.props.addProduct(product);
    history.push("/product-list");
  };

  render() {
    return (
      <div className="create-product">
        <div className="create-product__header">
          <h1 className="create-product__title">Додати Новий Товар</h1>
          <p className="create-product__subtitle">Заповніть інформацію про новий товар</p>
        </div>
        <div className="create-product__form-container">
          <ProductForm saveHandler={this.saveProductHandler} />
        </div>
      </div>
    );
  }
}

export default connect(null, { addProduct })(CreateProductPage);
